// export const API_URL = 'https://mirror-transport.mirror.edunixsystem.com/'
// export const API_URL = 'https://transport-api.motherland.edunixsystem.com/'
// export const API_URL = 'https://bus-api.rowadalmustakbal.edunixsystem.com/'
// export const API_URL = 'https://transport-api.albayan-schools.com/'
// export const API_URL = 'https://bus-api.alnukhbeh-edu.com/'
export const API_URL = 'https://bus-api.qimmah.edunixsystem.com/'
